<fa-icon [icon]="$any(icon)" [spin]="spin"></fa-icon>
